<template>
    <component :is="tag">
        <slot
            :brief="brief"
            :task="task"
            :is-loading="isLoading"
            :errors="errors"
            :error-message="errorMessage"
            :on-page-close="onPageClose"
            :deliverables="deliverables"
            :on-back="onBack"
        />
    </component>
</template>

<script>
    import { get } from 'lodash';
    import ActivationBriefTasksMixin from '../mixins/ActivationBriefTasksMixin';
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';
    import ContactsMixin from '../mixins/ContactsMixin';

    export default {
        name: 'ActivationDeliverablesProvider',
        mixins: [ContactsMixin, BaseActivationBriefStepMixin, ActivationBriefTasksMixin],
        data() {
            const exitRoute =
                this.$route.params.context === 'summary' ? 'v2.activation.tasks.summary' : 'v2.activation.brief.tasks';
            const backRoute = this.$route.params.back_route || 'v2.activation.brief.tasks';
            const context = this.$route.params.context;

            return {
                isLoading: false,
                exitRoute,
                context,
                backRoute
            };
        },
        async created() {
            this.isLoading = true;

            try {
                await this.loadContact(true);
                await this.loadActivationBrief(true);
            } catch (error) {
                this.handleHttpError(error);
            }

            this.isLoading = false;
        },

        computed: {
            deliverables() {
                return get(this.brief, 'deliverables', []).filter(
                    (deliverable) => deliverable.task_id === parseInt(this.taskParamId)
                );
            }
        },

        methods: {
            onPageClose() {
                this.$router.push({
                    name: this.exitRoute,
                    params: { context: this.context }
                });
            },
            onBack() {
                this.$router.push({
                    name: this.backRoute,
                    params: { context: this.context }
                });
            }
        }
    };
</script>
